
import {camelCase, isEmpty} from "lodash";

/*
 * Various methods for extracting data from
 * the 'product' object.
 */


export function isOutOfStock(product) {
  if (!product) return false;

  // snake_case agnostic
  let status = camelCase(product.buyableStatus || product.buyable_status);

  return (status === "outOfStock") || (status === 'discontinued');
}

export function parseBulletText(text) {
  if (!text) return [];

  return text.toString().split('@@');
}

export function mergeProductSpecs({labels, specs}) {
  if (isEmpty(specs) || isEmpty(labels))
    return null;

  return labels.map((label) => {
    let out = {label, values: []};
    let labelId = +(label.id);

    for (let spec of specs) {
      let target = spec.labelId;
      if (target && target === labelId) {
        out.values.push(spec.value);
      }
    }
    return out;
  });
}

export function nolCoreCartUrl(product) {
  if (!product) return null;

  const location = document.location || window.location || {};

  const isCarlyle = ("" + location.host).includes("carlyle");

  const base = "https://www.napaonline.com/en/p/"
  const brandCode = nolCoreBrandPrefix(product.brandId); // CARLYLE ONLY

  const params = { };
  if (("" + location.host).includes("carlyle")) {
    params['source'] = "carlyle";
    params['carlyle_category'] = ( ''+location.pathname).split('/')[1];
  }

  const qs = new URLSearchParams(params).toString()
  const url = [ base, brandCode, product.vendorsku, '?', qs].join('');
  return url;
}

const NOL_BRAND_PREFIXES = {
  442: "cht"
}
export function nolCoreBrandPrefix(brandId) {
  brandId = +brandId;

  let value = NOL_BRAND_PREFIXES[brandId];
  if (value) return value;

  console.error(`no brand prefix for brand id ${brandId}`);
  return "";
}
